import {Component} from "@angular/core";
import {Field} from "../models/field.model";


/**
 *
 * Class FormObjectComponent
 *
 * @desc Komponente für ein Objekt, das als einklappbares Feld dargestellt wird - kann beliebig weitere nested Objects enthalten
 */
@Component({
	selector: "tig-form-object",
	template: `
		<div
			*ngIf="OBJ_field_config.tab != true"
			class="form-group"
			[formGroup]="OBJ_form_group">
            <div [formGroupName]="OBJ_field_config.name" class="col-lg-12">
                <accordion>
                    <accordion-group [panelClass]="'panel-primary'" [isOpen]="OBJ_field_config?.open">
	                    <div accordion-heading>
		                    <i class="fa fa-angle-down"></i> {{getLabelName()|translate}}
	                    </div>
						<ng-container
								*ngFor="let OBJ_field of OBJ_field_config.fields"
								tigDynamicField
								[OBJ_field_config]="OBJ_field"
								[OBJ_form_group]="OBJ_form_group.controls[OBJ_field_config.name]">
						</ng-container>
                    </accordion-group>
                </accordion>
            </div>
        </div>
	`
})
export class FormObjectComponent extends Field {} // end class FormArrayComponent
